import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../Util";
var TextSkeleton = function (_a) {
    var width = _a.width, _b = _a.height, height = _b === void 0 ? "h-2" : _b, _c = _a.pulse, pulse = _c === void 0 ? true : _c, _d = _a.color, color = _d === void 0 ? "bg-gray-300" : _d;
    return (_jsx("div", { role: "status", className: classNames("rounded-full w-full inline-block", pulse ? "animate-pulse" : "", height, width ? width : "", color) }));
};
export default TextSkeleton;
